import Bits from '../../../bits';
import Modules from '../../../modules';


class SectionController {

	types = ['bits', 'modules'];

	bits = Bits;
	modules = Modules;

	container;

	globals = {};

	pages = {};

	initialize(slug, scope = this.container) {
		if (!this.pages[slug]) this.pages[slug] = [];
		for (const type of this.types) {
			for (const selector in this[type]) {
				const els = scope.querySelectorAll(`.${selector}`);
				for (const el of els) {
					try {
						this.pages[slug].push(new this[type][selector](el, slug));
					} catch (e) {
						console.warn(`Module [${selector}] failed to initialize`, e); // eslint-disable-line no-console
					}
				}
			}
		}
	}

	initializeGlobals(scope = this.container) {
		for (const type of this.types) {
			for (const selector in this[type]) {
				const els = document.querySelectorAll(`.${selector}`);
				for (const el of els) {
					if (!scope.contains(el)) this.globals[selector] = new this[type][selector](el);
				}
			}
		}
	}

	updateGlobal(id, data) {
		if (this.globals[id]) {
			for (const d in data) this.globals[id][d] = data[d];
		}
	}

	destroy(slug) {
		if (this.pages[slug]) {
			for (const m of this.pages[slug]) {
				if (m.destroy) {
					try {
						m.destroy();
					} catch (e) {
						console.warn('Module failed to be destroyed', m, e); // eslint-disable-line no-console
					}
				} else {
					console.warn('Missing destroy function!', m); // eslint-disable-line no-console
				}
			}
			delete this.pages[slug];
		}
	}

}

export default new SectionController();
